import { colors } from '@/theme/foundations/colors';

export const fieldContainerStyles = {
  margin: '1em 0',
  paddingLeft: '0px',
};

export const fieldLabelStyles = {
  overflow: 'hidden',

  fontSize: '14px',
  fontWeight: '650',
  color: colors['secondary-900'],
};

export const fieldSubLabelStyles = {
  fontSize: '14px',
  fontWeight: '550',
  color: colors['secondary-900'],
};
